<prlw-mobile-overlay-card-ui
  label="Цена на месте"
  (eventClickX)="eventClose.emit()"
  class="basis-best-price-mobile-price-options"
>
  <div body *ngIf="items; else empty" class="container">
    <div
      *ngFor="let item of items"
      class="flex row"
      (click)="eventClick.emit(item.id)"
    >
      <div class="grow text-left" [class.bold]="item.checked">
        {{ item.text }}
      </div>
      <div>{{ item.value | delimitNumber }}</div>
      <div class="icon-checked">
        <svg
          *ngIf="item.checked"
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="9.17651" cy="9.82349" r="9.07349" fill="black" />
          <path
            d="M6.0625 9.2383L8.79585 11.9716L12.9375 6.1875"
            stroke="white"
            stroke-width="1.5"
          />
        </svg>
      </div>
    </div>
  </div>
</prlw-mobile-overlay-card-ui>

<ng-template #empty>Нет данных</ng-template>
